<template>
  <div class="crop-upload-image-modal">
    <modal
      v-if="modalData.show"
      @close="closeModal"
      :clickOutsideToClose="clickOutsideToClose"
    >
      <template slot="header">
        <h3 class="modal-title">
          {{ $t("upload_image.upload") }}
        </h3>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closeModal"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <crop-upload-image
          @setImageSrc="setImageSrc"
          @setCroppedImageSrc="setCroppedImageSrc"
          :guides="guides"
          :view-mode="viewMode"
          :drag-mode="dragMode"
          :auto-crop-area="autoCropArea"
          :min-container-width="minContainerWidth"
          :min-container-height="minContainerHeight"
          :background="background"
          :rotatable="rotatable"
          :img-style="imgStyle"
          :aspect-ratio="aspectRatio"
          :modal-action="modalData.action"
          :origin-img-src="originImgSrc"
        ></crop-upload-image>
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal } from "@/components";
import CropUploadImage from "./CropUploadImage";
export default {
  name: "CropUploadImageModal",
  data() {
    return {};
  },
  components: {
    Modal,
    CropUploadImage
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    setImageSrc(image) {
      console.log("imageSrc");
    },
    setCroppedImageSrc(image) {
      this.$emit("setCroppedImageSrc", image, this.modalData);
      this.closeModal();
    }
  },
  props: {
    originImgSrc: {
      type: String,
      default: null
    },
    viewMode: {
      type: Number,
      default: 1
    },
    dragMode: {
      type: String,
      default: "crop"
    },
    minContainerHeight: {
      type: Number
    },
    minContainerWidth: {
      type: Number
    },
    aspectRatio: {
      type: Number
    },
    responsive: {
      type: Boolean,
      default: true
    },
    restore: {
      type: Boolean,
      default: true
    },
    checkCrossOrigin: {
      type: Boolean,
      default: true
    },
    checkOrientation: {
      type: Boolean,
      default: true
    },
    crossorigin: {
      type: String
    },
    modal: {
      type: Boolean,
      default: true
    },
    modalData: {
      type: Object,
      default: Object
    },
    guides: {
      type: Boolean,
      default: true
    },
    center: {
      type: Boolean,
      default: true
    },
    highlight: {
      type: Boolean,
      default: true
    },
    background: {
      type: Boolean,
      default: true
    },
    autoCrop: {
      type: Boolean,
      default: true
    },
    autoCropArea: Number,
    movable: {
      type: Boolean,
      default: true
    },
    rotatable: {
      type: Boolean,
      default: true
    },
    scalable: {
      type: Boolean,
      default: true
    },
    zoomable: {
      type: Boolean,
      default: true
    },
    zoomOnTouch: {
      type: Boolean,
      default: true
    },
    zoomOnWheel: {
      type: Boolean,
      default: true
    },
    wheelZoomRatio: Number,
    cropBoxMovable: {
      type: Boolean,
      default: true
    },
    cropBoxResizable: {
      type: Boolean,
      default: true
    },
    toggleDragModeOnDblclick: {
      type: Boolean,
      default: true
    },
    imgStyle: {
      type: Object
    },
    clickOutsideToClose: { type: Boolean, default: true }
  },
  mounted() {
    console.log("this.modalData", this.modalData);
  }
};
</script>

<style scoped></style>
